import { useState, useEffect } from 'react';

const useFetchData = (url) => {
    const [items, setitems] = useState([]);

    useEffect(() => {
        fetch(`${url}`)
            .then(res => res.json())
            .then(data => {
                setitems(Array.isArray(data) ? data : []);
            })
            .catch(() => setitems([]));
    }, [])

    return {items};
};

export default useFetchData;
